














































































import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    pageDataType,
    BrandPageDataType
} from "../types";
import {
    FETCH_BRAND_DATA,
    // FETCH_PAGE_BY_ID
} from "../store/actions.names";
import {
    API_URL,
    HOST
} from "../global";
import {
    pageData
} from "../store/pageData";
import axios from "axios";
import {
    SET_BRAND_CURRENT_PAGE,
    SET_BRAND_DATA,
    CURRENT_PAGE_ERROR,
    SET_BRAND_PARENT_PAGE
} from "../store/mutations.names";

import BrandsExp from "../components/BrandsExp.vue";
import BrandsInn from "../components/BrandsInn.vue";
import BrandSingleTitle from "../components/BrandSingleTitle.vue";
import BannerTextBlock from "../components/BannerTextBlock.vue";
@Component({
    name: "BrandPage",
    components: {
        banner: BannerTextBlock,
        title_text_image: BrandsExp,
        image_text_cta: BrandsInn,
        brand_title: BrandSingleTitle
    }
})
export default class BrandPage extends Vue {
    @Prop() public pageData!: pageDataType;
    //  @Prop() item!: pageDataType;

    @Getter("pageType") public pageType!: string | null;
    @Getter("brandData") public brandData!: BrandPageDataType[];
    @Action(FETCH_BRAND_DATA) public fetchData: any;
    @Mutation(SET_BRAND_CURRENT_PAGE) public[SET_BRAND_CURRENT_PAGE]: any;
    // @Action(FETCH_PAGE_BY_ID)[FETCH_PAGE_BY_ID]: any;
    public HOST: string = HOST;
    public posts: any[] = [];

    genColorString(color: string | Array < number > ): string {
        if (typeof color == 'string') {
            return color
        } else {
            return `rgb(${color.join(", ")}, 1.0)`
        }
    }

    public created() {
        axios.get(`${API_URL}/pages/?child_of=${(this as any).pageData.meta.parent.id}`)
            .then(response => {
                (this as any).posts = response.data
            })
            .catch(e => {
                (this as any).errors.push(e)
            })

    }
    // mounted() {
    //     this[FETCH_PAGE_BY_ID]();
    // }

}
